<template>
	<v-menu ref="dateMenu" v-model="dateMenu" :close-on-content-click="false" left transition="scale-transition" offset-y
		min-width="auto">
		<template v-slot:activator="{ on, attrs }">
			<v-row class="ma-0 pa-0" align="center" v-bind="attrs" v-on="on">
				<v-col v-if="viewCalendarIcon" class="ma-0 pa-0" cols="3" style="min-width:2rem;">
					<v-img height="2rem" width="2rem" class="ma-0 pa-0" src="@/assets/images/calendar.png"></v-img>
				</v-col>
				<v-col class="ma-0 pa-0" :cols="viewCalendarIcon ? 9 : 12" v-if="viewTextField">
					<v-text-field v-model="textDateValue" dark hide-details dense outlined append-icon="mdi-menu-down" readonly
						background-color="#272727" :style="{ fontSize: fontSize }">
					</v-text-field>
				</v-col>
			</v-row>
		</template>
		<v-date-picker v-model="dateValue" no-title scrollable :events="DateEvents" event-color="blue"
			:picker-date.sync="pickerDate" :min="min" :max="max" dark show-adjacent-months first-day-of-week="1">
			<v-row class="ma-0 pa-0" align="center" justify="space-between" v-if="time">
				<v-row class="ma-0 pa-0" align="center">
					<v-col class="ma-0 pa-0" cols="4">
						<v-row class="ma-0 pa-0" align="center" id="date_picker_row">
							<v-col class="ma-0 pa-0" cols="8" id="picker_bottom_menu">
								<v-row class="ma-0 pa-0" align="center" justify="space-between">
									<v-col class="ma-0 pa-0" cols="9">
										<input type="number" v-model="pickerHour" min="0" max="23" id="date_picker_input">
									</v-col>
									<v-col class="ma-0 pa-0" cols="3" id="btn_col">
										<v-row class="ma-0 pa-0" style="height: 1rem;" align="end" @click="countUp('Hour')">
											<v-img class="ma-0 pa-0 mb-1 mr-1" id="img_up"
												src="@/assets/images/icon_arrow_up_small.png"></v-img>
										</v-row>
										<v-row class="ma-0 pa-0" style="height: 1rem;" align="start" @click="countDown('Hour')">
											<v-img class="ma-0 pa-0 mt-1 mr-1" id="img_down"
												src="@/assets/images/icon_arrow_down_small.png"></v-img>
										</v-row>
									</v-col>
								</v-row>
							</v-col>
							<v-col class="ma-0 pa-0 pl-1" cols="auto">{{ t('hour') }}</v-col>
						</v-row>
					</v-col>
					<v-col class="ma-0 pa-0" cols="4">
						<v-row class="ma-0 pa-0" align="center" id="date_picker_row">
							<v-col class="ma-0 pa-0" cols="8" id="picker_bottom_menu">
								<v-row class="ma-0 pa-0" align="center" justify="space-between">
									<v-col class="ma-0 pa-0" cols="9">
										<input type="number" v-model="pickerMinute" min="0" max="23" id="date_picker_input">
									</v-col>
									<v-col class="ma-0 pa-0" cols="3" id="btn_col">
										<v-row class="ma-0 pa-0" style="height: 1rem;" align="end" @click="countUp('Minute')">
											<v-img class="ma-0 pa-0 mb-1 mr-1" id="img_up"
												src="@/assets/images/icon_arrow_up_small.png"></v-img>
										</v-row>
										<v-row class="ma-0 pa-0" style="height: 1rem;" align="start" @click="countDown('Minute')">
											<v-img class="ma-0 pa-0 mt-1 mr-1" id="img_down"
												src="@/assets/images/icon_arrow_down_small.png"></v-img>
										</v-row>
									</v-col>
								</v-row>
							</v-col>
							<v-col class="ma-0 pa-0 pl-1" cols="auto">{{ t('minute') }}</v-col>
						</v-row>
					</v-col>
					<v-col class="ma-0 pa-0" cols="4">
						<v-row class="ma-0 pa-0" align="center" id="date_picker_row">
							<v-col class="ma-0 pa-0" cols="8" id="picker_bottom_menu">
								<v-row class="ma-0 pa-0" align="center" justify="space-between">
									<v-col class="ma-0 pa-0" cols="9">
										<input type="number" v-model="pickerSecond" min="0" max="23" id="date_picker_input">
									</v-col>
									<v-col class="ma-0 pa-0" cols="3" id="btn_col">
										<v-row class="ma-0 pa-0" style="height: 1rem;" align="end" @click="countUp('Second')">
											<v-img class="ma-0 pa-0 mb-1 mr-1" id="img_up"
												src="@/assets/images/icon_arrow_up_small.png"></v-img>
										</v-row>
										<v-row class="ma-0 pa-0" style="height: 1rem;" align="start" @click="countDown('Second')">
											<v-img class="ma-0 pa-0 mt-1 mr-1" id="img_down"
												src="@/assets/images/icon_arrow_down_small.png"></v-img>
										</v-row>
									</v-col>
								</v-row>
							</v-col>
							<v-col class="ma-0 pa-0 pl-1" cols="auto">{{ t('second') }}</v-col>
						</v-row>
					</v-col>
				</v-row>
				<v-col class="ma-0 pa-0 pt-2" cols="12" v-if="confirm" align="center">
					<v-btn class="ma-0 pa-0" id="blue_btn" @click="dateMenu = false" width="8rem" height="2rem">{{ t('sure')
					}}</v-btn>
				</v-col>
			</v-row>
		</v-date-picker>
	</v-menu>
</template>

<script>
import mixin from '@/mixin';
import { mapState } from 'vuex';

export default {
	props: {
		viewCalendarIcon: { type: Boolean, default: true }, // 캘린더 아이폰 표시 여부
		viewTextField: Boolean, // 필수!! textInput 표시여부
		eventExist: { type: Boolean, default: false }, // 계약기간 표시할때 true로 진입
		time: { type: Boolean, default: true }, // textField와 picker 하단에 시분초 timnePicker 표시할때 true로 진입
		confirm: { type: Boolean, default: true }, // 하단에 확정 버튼을 지우고싶을때 false로 진입
		hour: Number,
		minute: Number,
		second: Number,
		matricDateList: Array,
		reset: String, // 날짜 초기화
		validPeriod: Boolean, // 권한설정에서 계약기간 설정할때 true로 받아서 진입
		defaultOneday: Boolean, // 권한설정 마감일 날짜 1일 default
		defaultMax: Boolean, // 권한설정 마감일 날짜 30일 default
		default90Max: Boolean, // 권한설정 마감일 날짜 90일 default
		initDate: { type: Boolean, default: false }, // default로 -7일 설정하기위해 true로 받아서 진입
		filteredData: { type: String, default: '' },
		recordingCkeck: { type: Boolean, default: false }, // 녹화 계약기간 체크 여부, 비디오플레이어에서 항상 true로 받아올것
		recordingPeriod: { type: Number, default: 30 }, // 녹화 계약기간
		disableFuture: { type: Boolean, default: false }, // 날짜 선택 미래 선택이 가능한지의 여부, true 미래선택 불가
		// disableFuture와 recordingCkeck이 동시에 true값을 받으면 안됨
		fontSize: { type: String, default: '0.65rem' }, // textField 폰트 사이즈
		limitMinDate: { type: String, default: '' },
		limitMaxDate: { type: String, default: '' },
		preserveDateOnOpen: { type: Boolean, default: false },
	},
	computed: {
		...mapState('player', ['dateList']),
	},
	components: {

	},
	mixins: [mixin.common],
	data: () => ({
		dateMenu: false,
		dateValue: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10),
		textDateValue: `${(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10)} ${new Date().getHours().toString().padStart(2, '0')}:${new Date().getMinutes().toString().padStart(2, '0')}`,
		dates: [(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10)],
		pickerHour: new Date().getHours(),
		pickerMinute: new Date().getMinutes(),
		pickerSecond: new Date().getSeconds(),
		DateEvents: [],
		pickerDate: null,
		selectedDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10),
		min: '2000-01-01',
		max: new Date((new Date()).setFullYear(new Date().getFullYear() + 2)).toISOString().substring(0, 10),
	}),
	watch: {
		dateMenu: function (item) {
			if (item) {
				this.makeMinMax(this.recordingCkeck);
				this.setMax();
				if (!this.preserveDateOnOpen) {
					if (this.initDate) {
						let initDate = new Date();
						this.dateValue = new Date(initDate.setDate(initDate.getDate() - 7)).toISOString().substring(0, 10);
					} else {
						this.dateValue = new Date().toISOString().substring(0, 10);
					}
				}
			}
		},
		reset: function (item) {
			if (item != '') {
				if (this.initDate) {
					let initDate = new Date();
					this.dateValue = new Date(initDate.setDate(initDate.getDate() - 7)).toISOString().substring(0, 10);
					this.resetPicker();
				} else {
					this.dateValue = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10);
					this.resetPicker();
				}
			}
		},
		dateValue: function (item) {
			if (this.time) {
				const setHour = String(this.pickerHour).padStart(2, '0');
				const setMinute = String(this.pickerMinute).padStart(2, '0');
				this.textDateValue = `${item} ${setHour}:${setMinute}`;
			}
			else this.textDateValue = `${item}`;
			this.makeDateEndEmit();
		},
		pickerDate: function (item) {
			this.$emit('changeDate', item);
		},
		pickerHour: function (hour) {
			if (hour >= 24) this.pickerHour = 23;
			if (hour.length > 2 || hour == '' || hour.toString() == '00') this.pickerHour = 0;
			const setHour = String(hour).padStart(2, '0');
			const setMinute = String(this.pickerMinute).padStart(2, '0');
			if (this.time) this.textDateValue = `${this.dateValue} ${setHour}:${setMinute}`;
			else this.textDateValue = `${this.dateValue}`;
			this.makeDateEndEmit();
			this.$emit('changeHour', Number(hour));
		},
		pickerMinute: function (minute) {
			if (minute >= 60) this.pickerMinute = 59;
			if (minute.length > 2 || minute == '' || minute.toString() == '00') this.pickerMinute = 0;
			const setHour = String(this.pickerHour).padStart(2, '0');
			const setMinute = String(minute).padStart(2, '0');
			if (this.time) this.textDateValue = `${this.dateValue} ${setHour}:${setMinute}`;
			else this.textDateValue = `${this.dateValue}`;
			this.makeDateEndEmit();
			this.$emit('changeMinute', Number(minute));
		},
		pickerSecond: function (second) {
			if (second >= 60) this.pickerSecond = 59;
			if (second.length > 2 || second == '' || second.toString() == '00') this.pickerSecond = 0;
			this.makeDateEndEmit();
			this.$emit('changeSecond', Number(second));
		},
		dates: {
			deep: true,
			handler(val, oldVal) {
				let result = val;
				this.$emit('resultDate', result);
			}
		},
		matricDateList: {
			deep: true,
			handler(val, oldVal) {
				this.makeEventList();
			}
		},
		hour: function (item) {
			this.pickerHour = item;
		},
		minute: function (item) {
			this.pickerMinute = item;
		},
		second: function (item) {
			this.pickerSecond = item;
		},
		dateList: function (item) {
			this.makeMinMaxOffline(item);
		},
		limitMinDate: function (item) {
			if (item != '') this.min = item;
		},
		limitMaxDate: function (item) {
			if (item != '') this.max = item;
		}
	},
	created() {
		if (this.filteredData == undefined || this.filteredData == '') {
			this.makeMinMax(this.recordingCkeck);
			this.setMax();
			if (this.defaultMax == true) {
				this.dateValue = this.max;
			}
			if (this.default90Max == true) {
				let date = new Date();
				this.dateValue = new Date(date.setDate(date.getDate() + 90)).toISOString().substring(0, 10);
			}
			if (this.defaultOneday == true) {
				let initDate = new Date();
				this.dateValue = new Date(initDate.setDate(initDate.getDate() + 1)).toISOString().substring(0, 10);
			}
			if (this.initDate) {
				let initDate = new Date();
				this.dateValue = new Date(initDate.setDate(initDate.getDate() - 7)).toISOString().substring(0, 10);
			}
		} else {
			this.setMax();
			this.pickerHour = this.filteredData.substring(11, 13) * 1;
			this.pickerMinute = this.filteredData.substring(14, 16) * 1;
			this.pickerSecond = this.filteredData.substring(17, 19) * 1;
			this.dateValue = this.filteredData.substring(0, 10);
		}
	},
	mounted() {
		let minutes = new Date().getMinutes();
		minutes = minutes >= 10 ? minutes : `0${minutes}`;
		this.textDateValue = this.time
			? `${this.dateValue} ${String(this.pickerHour).padStart(2, '0')}:${String(this.pickerMinute).padStart(2, '0')}`
			: `${this.dateValue}`;
		setTimeout(() => {
			if (this.eventExist == false) this.makeDateEndEmit();
			if (this.hour != undefined) {
				this.pickerHour = this.hour;
				this.pickerMinute = this.minute;
				this.pickerSecond = this.second;
			}
		}, 200);
	},
	methods: {
		resetPicker() {
			this.pickerHour = this.getCurrentHour()
			this.pickerMinute = this.getCurrentMinute()
			this.pickerSecond = 0
		},
		getDateAWeekAgo() {
			const yyyymmdd = new Date(new Date().setDate(new Date().getDate() - 7)).toISOString().substring(0, 10)
			return yyyymmdd
		},
		getToday() {
			const yyyymmdd = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10)
			return yyyymmdd
		},
		getCurrentHour() {
			return String(new Date().getHours()).padStart(2, '0');
		},
		getCurrentMinute() {
			return String(new Date().getMinutes()).padStart(2, '0');
		},
		makeMinMax(recording) {
			if (recording == true) { // 비디오 플레이어에서 녹화기간이 매번 다른경우
				let date = new Date();
				this.min = new Date(date.setDate(date.getDate() - this.recordingPeriod)).toISOString().substring(0, 10);
				this.max = new Date().toISOString().substring(0, 10);
			}
			if (this.dateList.length > 0) this.makeMinMaxOffline(this.dateList);
		},
		makeMinMaxOffline(dateList) {
			this.min = new Date(Math.min(...dateList.map(d => new Date(d).getTime()))).toISOString().substring(0, 10);
			this.max = new Date(Math.max(...dateList.map(d => new Date(d).getTime()))).toISOString().substring(0, 10);
		},
		setMax() {
			if (this.disableFuture) {
				this.max = new Date().toISOString().substring(0, 10);
			}
			if (this.limitMaxDate) {
				this.max = this.limitMaxDate;
			}
			if (this.limitMinDate) {
				this.min = this.limitMinDate;
			}
		},
		makeEventList() {
			if (this.matricDateList == undefined) return;
			this.DateEvents = [];
			this.matricDateList.forEach((item) => {
				this.DateEvents.push(new Date(new Date(item).getTime()).toISOString().substring(0, 10));
			});
		},
		countUp(item) {
			if (item == "Hour") {
				if (this.pickerHour + 1 <= 23)
					this.pickerHour += 1;
			} else if (item == "Minute") {
				if (this.pickerMinute + 1 <= 59)
					this.pickerMinute += 1;
			} else {
				if (this.pickerSecond + 1 <= 59)
					this.pickerSecond += 1;
			}
		},
		countDown(item) {
			if (item == "Hour") {
				if (this.pickerHour - 1 >= 0)
					this.pickerHour -= 1;
			} else if (item == "Minute") {
				if (this.pickerMinute - 1 >= 0)
					this.pickerMinute -= 1;
			} else {
				if (this.pickerSecond - 1 >= 0)
					this.pickerSecond -= 1;
			}
		},
		makeDateEndEmit() {
			const setHour = String(this.pickerHour).padStart(2, '0');
			const setMinute = String(this.pickerMinute).padStart(2, '0');
			const setSecond = String(this.pickerSecond).padStart(2, '0');
			const result = new Date(`${this.dateValue}T${setHour}:${setMinute}:${setSecond}`);
			this.$emit('resultDate', this.getFormatDate(result, 'java'));
		},
	}
}
</script>

<style lang="scss" scoped>
#picker_bottom_menu {
	background-color: #272727;
	border: 1px solid #4A4A4A;
	color: white;
	justify-content: start;
}

#date_picker_row {
	justify-content: space-evenly;
}

#img_up {
	width: 1rem;
	background-size: auto;
}

#img_down {
	width: 1rem;
	background-size: auto;
}

#date_picker_input {
	width: 100%;
	height: 100%;
	text-align: center;
	color: white;
	border: transparent;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	-webkit-appearance: none;
}

.v-list {
	background: #171921 !important;
	border: 1px solid #4A4A4A;
}

::v-deep {
	.v-list-item {
		min-height: 0px;
		color: white !important;
	}

	.v-list-item__content {
		color: white;
		padding: 5px 0;
	}

	// ######### DatePicker CSS #####
	.theme--dark.v-card {
		background-color: #171921;
		border: 1px solid #4A4A4A;
	}

	.theme--dark.v-picker__body {
		background-color: #171921;
	}

	.v-date-picker-header>.v-btn>.v-btn__content .v-icon {
		color: #40AEFF;
	}

	.v-date-picker-table thead tr th {
		&:nth-child(6) {
			color: #40AEFF;
		}

		&:nth-child(7) {
			color: #B54940;
		}
	}

	.v-date-picker-table tbody tr td {
		border-top: 1px solid #4A4A4A;

		&:nth-child(6) {
			.v-btn--disabled {
				.v-btn__content {
					color: rgba(255, 255, 255, 0.3) !important;
				}
			}

			.v-btn__content {
				color: #40AEFF;
			}
		}

		&:nth-child(7) {
			.v-btn--disabled {
				.v-btn__content {
					color: rgba(255, 255, 255, 0.3) !important;
				}
			}

			.v-btn__content {
				color: #B54940;
			}
		}
	}

	// ##############
	.v-date-picker-table--date .v-date-picker-table__events {
		bottom: 16px;
	}

	.v-date-picker-table__events {
		height: 15px;
		left: 0;
		position: absolute;
		text-align: center;
		white-space: pre;
		width: 100%;
	}

	.v-date-picker-table__events>div {
		border-radius: 50%;
		display: inline-block;
		height: 30px;
		width: 30px;
		opacity: 0.4;
	}
}
</style>